<ng-container *ngIf="!isEditMode">
  <div class="u-padding-16-0">
    <div class="u-marginBottom-16">
      <b i18n="@@profileView.hubs.interests"
        >{{ profile.first_name }} wants to talk about:</b
      >
    </div>
    <div fxLayout="row">
      <div *ngFor="let columnIndex of [0, 1]" fxFlex="0 0 50%">
        <div
          *ngFor="let interest of interestsChunks[columnIndex]"
          fxLayout="row"
          fxLayoutAlign="start center"
          class="u-paddingRight-16 u-marginBottom-8"
        >
          <mat-checkbox
            [checked]="industriesSelected[interest]"
            disabled="true"
            class="mat-checkbox--longText"
          >
            {{ interest }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="u-marginBottom-16">
      <b>{{ profile.first_name }} wants to share:</b>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="4px"
      class="u-marginBottom-8"
    >
      <p i18n="@@global.want" fxFlex="72px">Want</p>
      <p i18n="@@global.offer" fxFlex="72px">Offer</p>
    </div>
    <div
      *ngFor="let offerings of groupMembership.document.offerings"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="4px"
    >
      <div fxFlex="72px" class="u-marginBottom-8">
        <mat-checkbox [checked]="seekingSelected[offerings]" disabled="true">
        </mat-checkbox>
      </div>
      <div fxFlex="72px" class="u-marginBottom-8">
        <mat-checkbox [checked]="offeringsSelected[offerings]" disabled="true">
        </mat-checkbox>
      </div>
      <div fxFlex="calc(100% - 148px)">
        {{ offerings }}
      </div>
    </div>
  </div>
</ng-container>
@if (isEditMode) {
  <div class="u-paddingTop-24 u-borderBottom-standard">
    <div class="u-marginBottom-8">
      <b i18n="@@global.role">Role</b>
    </div>
    <mat-form-field [ngStyle]="{ 'max-width': '320px' }">
      <mat-select
        [(ngModel)]="groupMembership.role"
        (selectionChange)="onControlUpdate('role', $event.value)"
      >
        <mat-option
          *ngFor="let role of groupMembership.document.roles"
          [value]="role.name"
          [nz-tooltip]="role.name"
          [nzTooltipMouseEnterDelay]="0.5"
        >
          {{ role.name | translationLookup: ['@@groupRole'] }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  @for (
    segment of groupMembership?.document?.custom_segments ?? [];
    track segment._id
  ) {
    @if (segment.nodes?.length) {
      <div class="u-borderBottom-standard u-paddingTop-16">
        <app-group-custom-segment-header
          [customSegment]="segment"
          [user]="user"
        ></app-group-custom-segment-header>
        <mat-form-field [ngStyle]="{ 'max-width': '320px' }">
          @if ('multi' !== segment.selection_type) {
            <mat-select
              [disabled]="
                !segment.privacy_settings?.editable_by_self && !isUserAdmin
              "
              [(ngModel)]="segmentationSelected[segment._id]"
              (selectionChange)="updateSegmentSelections(segment, $event.value)"
              i18n-placeholder="
                @@profileView.completionWidget.segments.selectPlaceholder"
              placeholder="Select an option"
            >
              @for (node of segment.nodes; track $index) {
                <mat-option
                  [nz-tooltip]="node.name"
                  [nzTooltipMouseEnterDelay]="0.5"
                  [value]="node.name"
                >
                  {{
                    node.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  }}
                </mat-option>
              }
            </mat-select>
          }
          @if ('multi' === segment.selection_type) {
            <mat-select
              [disabled]="
                !segment.privacy_settings?.editable_by_self && !isUserAdmin
              "
              [(ngModel)]="segmentationSelected[segment._id]"
              (closed)="
                updateMultiSegmentSelections(
                  segment,
                  segmentationSelected[segment._id],
                  initialSegmentationSelected[segment._id]
                )
              "
              multiple
              placeholder="Select an option"
              i18n-placeholder="
                @@profileView.completionWidget.segments.selectPlaceholder"
            >
              @for (node of segment.nodes; track $index) {
                <mat-option [value]="node.name">
                  {{
                    node.name
                      | translationLookup: ['@@groupCustomSegmentOption']
                  }}
                </mat-option>
              }
            </mat-select>
          }
        </mat-form-field>
      </div>
    }
  }

  <div class="u-padding-16-0">
    <div class="u-marginBottom-8">
      <b i18n="@@global.selectInterests">Select your interests</b>
    </div>
    <ng-container
      *ngIf="
        (
          groupMembership.document?.field_descriptions
          | appFind: 'name' : 'industries'
        )?.description as interestsDescription
      "
    >
      <div
        class="color-grey-300 u-text-maxWidth u-marginBottom-8 u-whiteSpace-preLine"
      >
        {{
          interestsDescription
            | translationLookup: ['@@groupIndustriesDescription']
        }}
      </div>
    </ng-container>
    <div fxLayout="row">
      <div *ngFor="let columnIndex of [0, 1]" fxFlex="0 0 50%">
        <div
          *ngFor="let interest of interestsChunks[columnIndex]"
          fxLayout="row"
          fxLayoutAlign="start center"
          class="u-paddingRight-16"
        >
          <mat-checkbox
            [checked]="industriesSelected[interest]"
            (change)="
              onControlListUpdate('industries', interest, $event.checked)
            "
            class="mat-checkbox--longText"
          >
            {{ interest | translationLookup: ['@@groupIndustry'] }}
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="u-borderBottom-standard"></div>
  <div *ngIf="showEditLegacyGoals" class="u-padding-16-0">
    <div class="u-marginBottom-8">
      <b i18n="@@profileView.hubs.goals.selectTitle"
        >Select what you'd like to share</b
      >
    </div>
    <ng-container
      *ngIf="
        (
          groupMembership.document?.field_descriptions
          | appFind: 'name' : 'offerings'
        )?.description as goalsDescription
      "
    >
      <div
        class="color-grey-300 u-text-maxWidth u-marginBottom-8 u-whiteSpace-preLine"
      >
        {{
          goalsDescription | translationLookup: ['@@groupOfferingsDescription']
        }}
      </div>
    </ng-container>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="4px"
      class="u-marginBottom-8"
    >
      <p i18n="@@global.want" fxFlex="72px">Want</p>
      <p i18n="@@global.offer" fxFlex="72px">Offer</p>
    </div>
    <div
      *ngFor="let offerings of groupMembership.document.offerings"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="4px"
      class="u-marginBottom-8"
    >
      <div fxFlex="72px">
        <mat-checkbox
          [checked]="seekingSelected[offerings]"
          (change)="onControlListUpdate('seeking', offerings, $event.checked)"
          class="mat-checkbox--longText"
        >
        </mat-checkbox>
      </div>
      <div fxFlex="72px">
        <mat-checkbox
          [checked]="offeringsSelected[offerings]"
          (change)="onControlListUpdate('offerings', offerings, $event.checked)"
          class="mat-checkbox--longText"
        >
        </mat-checkbox>
      </div>
      <div fxFlex="calc(100% - 148px)">
        {{ offerings | translationLookup: ['@@groupOffering'] }}
      </div>
    </div>
  </div>
  <ng-container *ngIf="!isIntroOnly">
    <div class="u-borderBottom-standard"></div>
    <div class="u-padding-16-0">
      <b i18n="@@global.interactions">Interactions</b>
    </div>
    <div
      *ngIf="(tenantState | async)?.enabled_features?.conversations"
      class="u-marginBottom-16"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <div fxFlex="100" class="u-marginRight-16">
        <span
          i18n="@@profileView.hubs.interactions.inviteable.label"
          >{isUser, select,
            true {Other members can start a conversation with me}
            false {Can be messaged by other members}

        }</span>
      </div>
      <mat-slide-toggle
        fxFlex="none"
        [checked]="groupMembership.inviteable"
        (change)="onControlUpdate('inviteable', $event.checked)"
      >
      </mat-slide-toggle>
    </div>
    <div
      *ngIf="group.features_enabled?.introductions"
      class="u-marginBottom-16"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <div fxFlex="100" class="u-marginRight-16">
        <span>
          <ng-container
            *ngIf="isUser; else isNotUser"
            i18n="@@profilehubItem.interactions.receiveIntroductionsLabel"
            >Receive automated Introductions to other members</ng-container
          >
          <ng-template
            #isNotUser
            i18n="@@profilehubItem.interactions.canBeIntroducedLabel"
            >Can be introduced to other members automatically</ng-template
          >
        </span>
      </div>
      <mat-slide-toggle
        fxFlex="none"
        [checked]="groupMembership.opted_into_matchmaking"
        (change)="onControlUpdate('opted_into_matchmaking', $event.checked)"
      >
      </mat-slide-toggle>
    </div>
    <div class="u-marginBottom-16" fxLayout="row" fxLayoutAlign="start center">
      <div fxFlex="100" class="u-marginRight-16">
        <span
          i18n="@@profileView.hubs.interactions.searchable.label"
          >{isUser, select,
            true {Other members can search for my profile}
            false {Can be searched for by other members}

        }</span>
      </div>
      <mat-slide-toggle
        fxFlex="none"
        [checked]="groupMembership.searchable"
        (change)="onControlUpdate('searchable', $event.checked)"
      >
      </mat-slide-toggle>
    </div>
    <div class="u-borderBottom-standard"></div>
    <div class="u-padding-16-0" div fxLayout="row" fxLayoutAlign="end center">
      <button
        [disabled]="isLoading"
        (click)="promptDeleteGroup(groupMembership)"
        color="warn"
        mat-raised-button
      >
        <i
          *ngIf="isLoading"
          class="u-marginRight-8"
          nz-icon
          nzSpin
          nzTheme="outline"
          nzType="sync"
        ></i>
        <span *ngIf="isUser; else notUser" i18n="@@profileView.hubs.leaveHub"
          >Leave Hub</span
        >
        <ng-template #notUser
          ><span i18n="@@profileView.hubs.removeUser"
            >Remove from Hub</span
          ></ng-template
        >
      </button>
    </div>
  </ng-container>
}
